import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "~/lib/native-history"; // Must be first — captures native replaceState before router patches it.

import { applyBrand } from "~/brand";
import { captureMasslyticsSession } from "~/lib/masslytics";
import { loadViralLoopsScript } from "~/lib/viral-loops";

import { queryClient, router } from "./router";
import "./styles.css";

captureMasslyticsSession();
loadViralLoopsScript();

function renderApp() {
  const rootElement = document.getElementById("root")!;
  if (rootElement.innerHTML) return;

  const root = createRoot(rootElement);
  const strictMode = import.meta.env.VITE_STRICT_MODE !== "false";

  const app = (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {/* <ReactQueryDevtools buttonPosition="bottom-left" /> */}
    </QueryClientProvider>
  );

  root.render(strictMode ? <StrictMode>{app}</StrictMode> : app);
}

void applyBrand().finally(renderApp);
